import React from 'react';
import ResultsVehicles from './ResultsVehicles';
import BottomBar from '../components/BottomBar';
import { styled } from '@volkswagen-onehub/components-core';

const StyledContainer = styled.div`
  margin-top: ${({theme}) => theme.size.dynamic0050}
`;

const ResultsInit =  () => {
  return (
    <StyledContainer>
      <ResultsVehicles />
      <BottomBar />
    </StyledContainer>
  );
};

export default ResultsInit;
